export const setRentObject = (classificationId) => ({
  type: "RENT_OBJECTS/RENT_OBJECT_SELECTED",
  payload: {classificationId}
});
